import {
  ASSETS_AUDIO_ROUTE,
  ASSETS_IMAGES_ROUTE,
  ASSETS_ROUTE,
  ASSETS_VIDEOS_ROUTE,
  CONTENT_CAMPAIGNS_ROUTE,
  CONTENT_PLAYLISTS_ROUTE,
  CONTENT_ROUTE,
  DEPLOYMENTS_ROUTE,
  DEVICE_PERIPHERALS_ROUTE,
  DEVICE_PLAYERS_ROUTE,
  EXPERIENCES_ROUTE,
  LOCATIONS_ROUTE,
  SETTINGS_PROJECTS_ROUTE,
  SETTINGS_USERS_ROUTE,
} from "@ds/constants/router";

import { SETTINGS_INVITATIONS_ROUTE } from "./../../../constants/router/entity-routes";
import { DetailsTableDataTypeEnum, MainTableDataTypeEnum } from "./model";

export const getMainTableDataTypeByRoute = (pathname: string): MainTableDataTypeEnum => {
  const normalizedPathname = pathname.replace(/\/$/, "");
  switch (normalizedPathname) {
    case EXPERIENCES_ROUTE:
      return MainTableDataTypeEnum.Experiences;
    case DEVICE_PLAYERS_ROUTE:
      return MainTableDataTypeEnum.DevicePlayers;
    case DEVICE_PERIPHERALS_ROUTE:
      return MainTableDataTypeEnum.DevicePeripherals;
    case LOCATIONS_ROUTE:
      return MainTableDataTypeEnum.Locations;
    case CONTENT_CAMPAIGNS_ROUTE:
      return MainTableDataTypeEnum.ContentCampaigns;
    case CONTENT_PLAYLISTS_ROUTE:
      return MainTableDataTypeEnum.ContentPlaylists;
    case ASSETS_VIDEOS_ROUTE:
      return MainTableDataTypeEnum.AssetVideos;
    case ASSETS_IMAGES_ROUTE:
      return MainTableDataTypeEnum.AssetImages;
    case ASSETS_AUDIO_ROUTE:
      return MainTableDataTypeEnum.AssetAudio;
    case DEPLOYMENTS_ROUTE:
      return MainTableDataTypeEnum.Deployments;
    case SETTINGS_PROJECTS_ROUTE:
      return MainTableDataTypeEnum.Projects;
    case SETTINGS_USERS_ROUTE:
      return MainTableDataTypeEnum.Users;
    case SETTINGS_INVITATIONS_ROUTE:
      return MainTableDataTypeEnum.Invitations;
  }

  throw new Error(`Specify table data type for current route path: ${pathname}`);
};

export const getPageTitleByTableDataType = (tableType: MainTableDataTypeEnum | DetailsTableDataTypeEnum): string => {
  switch (tableType) {
    case MainTableDataTypeEnum.Experiences:
      return "Experiences";
    case MainTableDataTypeEnum.DevicePlayers:
      return "Players";
    case MainTableDataTypeEnum.DevicePeripherals:
      return "Peripherals";
    case MainTableDataTypeEnum.Locations:
      return "Locations";
    case MainTableDataTypeEnum.ContentCampaigns:
      return "Campaigns";
    case MainTableDataTypeEnum.ContentPlaylists:
      return "Playlists";
    case MainTableDataTypeEnum.AssetVideos:
      return "Videos";
    case MainTableDataTypeEnum.AssetImages:
      return "Images";
    case MainTableDataTypeEnum.AssetAudio:
      return "Audio";
    case MainTableDataTypeEnum.Deployments:
      return "Deployments";
    case MainTableDataTypeEnum.Projects:
      return "Projects";
    case MainTableDataTypeEnum.Users:
      return "Users";
    case MainTableDataTypeEnum.Invitations:
      return "Invitations";
  }

  return "";
};

export const getSectionCrumbByTableDataType = (
  tableType: MainTableDataTypeEnum,
): { label: string; route: string; listLabel?: string; listRoute?: string } | null => {
  switch (tableType) {
    case MainTableDataTypeEnum.ContentCampaigns:
      return { label: "Content", route: CONTENT_ROUTE, listLabel: "Campaigns", listRoute: CONTENT_CAMPAIGNS_ROUTE };
    case MainTableDataTypeEnum.ContentPlaylists:
      return { label: "Content", route: CONTENT_ROUTE, listLabel: "Playlists", listRoute: CONTENT_PLAYLISTS_ROUTE };
    case MainTableDataTypeEnum.AssetVideos:
    case MainTableDataTypeEnum.AssetImages:
    case MainTableDataTypeEnum.AssetAudio:
      return { label: "Assets", route: ASSETS_ROUTE };
    default:
      return null;
  }
};

export const isMainTableDataTypeEnum = (
  tableType: MainTableDataTypeEnum | DetailsTableDataTypeEnum,
): tableType is MainTableDataTypeEnum => {
  switch (tableType) {
    case MainTableDataTypeEnum.Experiences:
    case MainTableDataTypeEnum.DevicePlayers:
    case MainTableDataTypeEnum.DevicePeripherals:
    case MainTableDataTypeEnum.Locations:
    case MainTableDataTypeEnum.ContentCampaigns:
    case MainTableDataTypeEnum.ContentPlaylists:
    case MainTableDataTypeEnum.AssetVideos:
    case MainTableDataTypeEnum.AssetImages:
    case MainTableDataTypeEnum.AssetAudio:
    case MainTableDataTypeEnum.Deployments:
    case MainTableDataTypeEnum.Projects:
    case MainTableDataTypeEnum.Users:
    case MainTableDataTypeEnum.Invitations:
      return true;
  }

  return false;
};
